import React, { Component } from "react";
import withRouter from "../../../Utils/withRouter";
import { NavLink } from "react-router-dom";
import UpdatePayrollNavigationSideBar from "./UpdatePayrollNavigationSideBar";
import OverTime from "../../PayrollManagement/OverTime";
import Leaves from "../../PayrollManagement/Leaves";
import Attendence from "../../PayrollManagement/Attendence";
import HeadsAndStatutory from "../../PayrollManagement/HeadsAndStatutory";

class UpdatePayroll extends Component {
  render() {
    return (
      <div style={{ marginTop: 100, marginLeft: 50, marginRight: 50 }}>
        {/* start page title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <h4 className="mb-sm-0">Wizard</h4>
              <div className="page-title-right">
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item">
                    <a href="javascript: void(0);">Forms</a>
                  </li>
                  <li className="breadcrumb-item active">Wizard</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        {/* end page title */}
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title mb-0">Update Payroll</h4>
              </div>
              {/* end card header */}
              <div className="card-body">
                <form action="#" className="form-steps" autoComplete="off">
                  <div className="text-center pt-3 pb-4 mb-1">
                    <UpdatePayrollNavigationSideBar
                      employee_id={this.props.params.employee_id}
                    />

                    {/* <h5>Signup Your Account</h5> */}
                  </div>
                  <div id="custom-progress-bar" className="progress-nav mb-4">
                    <div className="progress" style={{ height: 1 }}>
                      <div
                        className="progress-bar"
                        role="progressbar"
                        style={{ width: "0%" }}
                        aria-valuenow={0}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      />
                    </div>
                  
                  </div>
                  <div className="tab-content">
                    {/* first tab  */}
                    <div
                      className="tab-pane fade show active"
                      id="pills-gen-info"
                      role="tabpanel"
                      aria-labelledby="pills-gen-info-tab"
                    >
                      <Leaves/>
                      
                    </div>
                    
                     
                    {/* end tab pane */}
                  </div>
                  {/* end tab content */}
                </form>
              </div>
              {/* end card body */}
            </div>
            {/* end card */}
          </div>
          {/* end col */}

          {/* end col */}
        </div>
        {/* end row */}
      </div>
    );
  }
}

export default withRouter(UpdatePayroll);
